import * as React from "react";
import { forwardRef } from "react";
const SvgAll = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 14, height: 14, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-svgr-icon": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "ci:check-all" }, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M4.66675 7.2828L7.1419 9.75795L12.091 4.80823M1.75 7.2828L4.22515 9.75795M9.17487 4.80823L7.29182 6.7082", stroke: "white", strokeWidth: 1.1667, strokeLinecap: "round", strokeLinejoin: "round" })));
const ForwardRef = forwardRef(SvgAll);
export { ForwardRef as ReactComponent };
